import { render, staticRenderFns } from "./folderPermissionDialog.vue?vue&type=template&id=7da3a70c&scoped=true"
import script from "./folderPermissionDialog.vue?vue&type=script&lang=js"
export * from "./folderPermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./folderPermissionDialog.vue?vue&type=style&index=0&id=7da3a70c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da3a70c",
  null
  
)

export default component.exports